export default function getSelectedItemIds(
  nonLaidOutLibraryItems,
  currentSections
) {
  const selectedItemIds = [
    ...nonLaidOutLibraryItems.map((item) => item.id),
    ...currentSections.flatMap((s) => s.items).map((item) => item.id),
  ];
  return selectedItemIds;
}
